import axios from "axios";

import { API_BASE_URL, ASSETS_ROUTE } from "../../config";
import { AssetsRepository } from "../../repositories/data/assets.repository";
import { assetsCacheStore } from "../../db/runtime.storage";


const STANDALONE_ASSETS_ROUTE: string = `${ASSETS_ROUTE}/standalone`;
const DEPENDENT_ASSETS_ROUTE: string = `${ASSETS_ROUTE}/dependent`;

export class AssetsService {
    private readonly assetsRepo: AssetsRepository = new AssetsRepository();

    public getStandaloneAssetUri(assetId: string): string {
        const key = assetId;

        const cached = assetsCacheStore.standaloneAssetUriCache.get(key);
        if (cached !== undefined) {
            console.info("[AssetsService] standalone asset uri cache hit:", { key });
            return cached;
        }

        const uri = `${API_BASE_URL}${STANDALONE_ASSETS_ROUTE}/${assetId}/content`;
        assetsCacheStore.setStandaloneAssetUri(key, uri);
        return uri;
    }

    public getDependentAssetUri(assetId: string): string {
        const key = assetId;

        const cached = assetsCacheStore.dependentAssetUriCache.get(key);
        if (cached !== undefined) {
            console.info("[AssetsService] dependent asset uri cache hit:", { key });
            return cached;
        }

        const uri = `${API_BASE_URL}${DEPENDENT_ASSETS_ROUTE}/${assetId}/content`;
        assetsCacheStore.setDependentAssetUri(key, uri);
        return uri;
    }

    public async getDependentAssetContent(id: string): Promise<any | undefined> {
        const key = id;

        const cached = assetsCacheStore.dependentContentCache.get(key);
        if (cached !== undefined) {
            console.info("[AssetsService] dependent asset content cache hit:", { key });
            return cached;
        }

        const inFlight = assetsCacheStore.dependentContentPending.get(key);
        if (inFlight) {
            console.info("[AssetsService] dependent asset content duplicated request recycled:", { key });
            return inFlight;
        }

        const request = this.assetsRepo
            .getDependentAsset(id)
            .then((data: any) => {
                const result = data ?? undefined;

                if (result !== undefined) {
                    assetsCacheStore.setDependentContent(key, result);
                }

                return result;
            })
            .catch((error: unknown) => {
                if (axios.isAxiosError(error)) {
                    if (error.response) {
                        console.error(error.response.data || "Erro ao obter conteúdo do ativo.");
                    } else if (error.request) {
                        console.error("Sem resposta do servidor");
                    } else {
                        console.error("Erro interno ao fazer a requisição.");
                    }
                }
                return undefined;
            })
            .finally(() => {
                assetsCacheStore.dependentContentPending.delete(key);
            });

        assetsCacheStore.dependentContentPending.set(key, request);
        return request;
    }
}